import { Box } from '@material-ui/core'

export interface TabBoxProps {
  active: boolean
  text: string
  count: number
  selectedCount: number
  onClick: () => void
  children: React.ReactNode
}

export const TabBox = ({
  active,
  text,
  count,
  onClick,
  selectedCount,
  children,
  ...rest
}: TabBoxProps): JSX.Element => {
  // const { t } = useTranslation()

  return (
    <Box onClick={onClick} {...rest}>
      {active && <>{children}</>}
    </Box>
  )
}
